/* Movatic WMS — Frontend | CesarFilho 932048016 */
/* CesarFilho 932048016 */
/* frontend/src/lib/theme.ts */

/**
 * Movatic WMS — Gestão de tema visual
 *
 * Decisão atual:
 * - O Movatic WMS deve iniciar sempre em modo escuro.
 * - Isto evita ecrãs híbridos, onde o fundo fica escuro mas os cards ficam brancos.
 * - O utilizador ainda pode alterar o tema pelo ThemeToggle, mas o padrão inicial é dark.
 */

const THEME_KEY = 'movatic.theme.v2' as const

export type Theme = 'light' | 'dark' | 'system'

function applyTheme(theme: Theme) {
    const root = document.documentElement
    const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches

    const useDark =
        theme === 'dark' ||
        (theme === 'system' && systemDark)

    root.classList.toggle('dark', useDark)
}

export function getTheme(): Theme {
    const saved = localStorage.getItem(THEME_KEY) as Theme | null

    /**
     * Padrão oficial do Movatic WMS:
     * iniciar em dark para manter dashboard, cards, tabelas e sidebar consistentes.
     */
    return saved ?? 'dark'
}

export function setTheme(theme: Theme) {
    localStorage.setItem(THEME_KEY, theme)
    applyTheme(theme)
}

export function initTheme() {
    applyTheme(getTheme())
}